// extracted by mini-css-extract-plugin
export default {"offerForm":"qw46WR_0OWe5MpEJCszA","offerFormSection":"mNNjwX4X3s4bIKE6aImv","onlyDesktop":"DsDINQHwpJaCLlEB2ZoQ"};